/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_EmptyInputs */



/**
* | output |
* | --- |
* | "That file has no header row or no data." |
*
* @param {Team_Manager_Import_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_empty = /** @type {((inputs?: Team_Manager_Import_EmptyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_EmptyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce fichier n'a pas de ligne d'en-tête ou pas de données.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Datei hat keine Kopfzeile oder keine Daten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il file non ha una riga di intestazione o non contiene dati.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В файле нет строки заголовков или данных.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El archivo no tiene fila de encabezado o no tiene datos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("该文件没有标题行或没有数据。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このファイルにはヘッダー行またはデータがありません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस फ़ाइल में हेडर पंक्ति या डेटा नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O ficheiro não tem linha de cabeçalho ou não tem dados.")
	return /** @type {LocalizedString} */ ("That file has no header row or no data.")
});